export default "__VITE_ASSET__Bf7vTiPu__"